import React from 'react';
import PropTypes from 'prop-types';

import ListingEmptyState from "components/Product/Table/ListingEmptyState";

import AttributeRow from "./AttributeRow";
import EnrichmentRowsSkeleton from "./EnrichmentRowsSkeleton";
import {Table, TableHeader} from "./EnrichmentTable";
import ImageGroupRow from "./ImageGroupRow";
import {isAttributeTab} from "../enrichmentConstants";

EnrichmentList.propTypes = {
    tab: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    rows: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    values: PropTypes.object.isRequired,
    selected: PropTypes.object.isRequired,
    onSelectedChange: PropTypes.func.isRequired,
    onValuesChange: PropTypes.func.isRequired,
    decisions: PropTypes.object.isRequired,
};

const ATTRIBUTE_COLUMNS = {
    missing: ['product', 'scoring', 'variants', 'attributes'],
    pending: ['product', 'scoring', 'variants', 'suggestion', 'action'],
    applied: ['product', 'scoring', 'variants', 'attributes', 'action'],
};
const IMAGE_COLUMNS = ['product', 'variants', 'pictures'];

function EnrichmentList({tab, state, rows, loading, values, selected, onSelectedChange, onValuesChange, decisions}) {
    if (!loading && 0 === rows.length) {
        return <ListingEmptyState titleId="enrichment.empty.title" descriptionId="enrichment.empty.description"/>;
    }

    const isAttributes = isAttributeTab(tab);
    const columns = isAttributes ? ATTRIBUTE_COLUMNS[state] : IMAGE_COLUMNS;
    const selectable = isAttributes && 'applied' !== state && !loading;
    const allSelected = selectable && rows.length > 0 && rows.every((product) => selected[product.id]);

    return (
        <Table>
            <TableHeader
                columns={columns}
                selectable={selectable}
                allSelected={allSelected}
                onSelectAll={() => onSelectedChange(allSelected ? {} : Object.fromEntries(rows.map((product) => [product.id, true])))}
            />
            {loading && <EnrichmentRowsSkeleton columns={columns}/>}
            {!loading && (isAttributes
                ? rows.map((product) => (
                    <AttributeRow
                        key={`${product.id}-${tab}-${state}`}
                        tab={tab}
                        product={product}
                        state={state}
                        values={values}
                        selected={Boolean(selected[product.id])}
                        onSelect={(item, value) => onSelectedChange((current) => ({...current, [item.id]: value}))}
                        onApply={decisions.applyProduct}
                        onApplyValues={decisions.applyValues}
                        onDismiss={decisions.dismissTargets}
                        onChoose={decisions.chooseValue}
                        onChangeApplied={decisions.changeAppliedValue}
                        onValuesChange={onValuesChange}
                        deciding={decisions.deciding}
                    />
                ))
                : rows.map((group) => <ImageGroupRow key={group.key} group={group}/>))}
        </Table>
    );
}

export default EnrichmentList;
